import React from 'react';
import { FaHome } from 'react-icons/fa';
import logo from '../../assets/logo.svg';
import './ExternalPageHeader.css';

const ExternalPageHeader = () => {
  return (
    <header className="external-page-header">
      <div className="header-logo">
        <img
          src={logo}
          alt="Logo Plantão Fácil"
          className="header-logo-image"
        />
      </div>
      <nav className="header-nav" aria-label="Main Navigation">
        <ul className="nav-list">
          <li className="nav-item">
            <a
              href="https://prontuariofacil.com.br"
              className="nav-link"
              aria-label="Página Inicial"
            >
              <FaHome
                className="home-icon"
                aria-hidden="true"
                focusable="false"
              />
              Página Inicial
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default ExternalPageHeader;
